import * as React from 'react';

import {SettingsPage} from '../components';
import {useCustomerStore} from "../../../redux/customers";

type Props = {
};

export const SettingsPageContainer: React.FC<Props> = props => {
    const customerStore = useCustomerStore();

    const {
        isFetching: customerIsFetching,
        activeCustomer,
    } = customerStore;

    const canEdit = !!(!customerIsFetching && activeCustomer?.company?.featuresSelfManage);
    const featuresMarketing = !!(activeCustomer?.company?.featuresMarketing) && !activeCustomer?.accountReadOnly;
    // Customer-level (not company-level) — auto-pay is gated per subscription, not per tenant.
    const showAutoPay = !!(activeCustomer?.autoPay?.available || activeCustomer?.autoPay?.active);

    return <SettingsPage
        customer={activeCustomer}
        canEditProfile={canEdit}
        canEditContact={canEdit}
        featuresMarketing={featuresMarketing}
        showAutoPay={showAutoPay}
    />;
};
